module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.list,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "公会ID",
      "align": "center",
      "prop": "guildNumber",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "会长信息",
      "align": "center",
      "prop": "",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("会长ID:" + _vm._s(scope.row.guildLeaderUserRecodeCode))]), _vm._v(" "), _c('div', [_vm._v("会长昵称:" + _vm._s(scope.row.guildLeaderUserNickName))]), _vm._v(" "), _c('div', [_vm._v("会长手机号:" + _vm._s(scope.row.guildLeaderUserPhone))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "avatar",
      "label": "公会头像",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.avatar) ? _c('el-popover', {
          attrs: {
            "placement": "top-start",
            "title": "",
            "trigger": "click",
            "content": ""
          }
        }, [_c('img', {
          staticStyle: {
            "width": "500px"
          },
          attrs: {
            "src": scope.row.avatar
          }
        }), _vm._v(" "), _c('img', {
          staticStyle: {
            "width": "50px",
            "height": "50px",
            "border-radius": "5px",
            "object-fit": "cover"
          },
          attrs: {
            "slot": "reference",
            "src": scope.row.avatar
          },
          slot: "reference"
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "公会名称",
      "align": "center",
      "prop": "guildName",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "公会简介",
      "align": "center",
      "prop": "intro",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.intro && scope.row.intro.length > 10) ? _c('div', [_c('el-popover', {
          attrs: {
            "placement": "top-start",
            "trigger": "hover",
            "content": scope.row.intro,
            "width": "300"
          }
        }, [_c('div', {
          staticClass: "intro",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_vm._v(_vm._s(scope.row.intro))])])], 1) : _c('div', {
          staticClass: "intro"
        }, [_vm._v(_vm._s(scope.row.intro))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "公会总人数",
      "align": "center",
      "prop": "memberNumber",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核状态",
      "align": "center",
      "prop": "bankCard",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.status === 0 ? '审核中' : scope.row.status === 1 ? '审核通过' : '审核拒绝'))]), _vm._v(" "), (scope.row.status == 2 && scope.row.auditRemarks) ? _c('div', [_vm._v("备注：" + _vm._s(scope.row.auditRemarks))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "提交时间",
      "align": "center",
      "prop": "createTime",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.timestampFormat(scope.row.createTime)))])]
      }
    }])
  }), _vm._v(" "), (_vm.user && _vm.user.isGuildLeader == 1) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleUpdate(scope.row)
            }
          }
        }, [_vm._v("修改公会")])]
      }
    }], null, false, 4009194680)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.open,
      "width": "500px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.open = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公会昵称",
      "prop": "guildName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "公会昵称"
    },
    model: {
      value: (_vm.form.guildName),
      callback: function($$v) {
        _vm.$set(_vm.form, "guildName", $$v)
      },
      expression: "form.guildName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公会简介",
      "prop": "intro"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "公会简介",
      "type": "textarea",
      "rows": 2
    },
    model: {
      value: (_vm.form.intro),
      callback: function($$v) {
        _vm.$set(_vm.form, "intro", $$v)
      },
      expression: "form.intro"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公会头像",
      "prop": "avatar"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader photo",
    attrs: {
      "list-type": "picture-card",
      "http-request": function (res) {
        return _vm.Upload(res, 'avatar')
      },
      "multiple": false,
      "show-file-list": false,
      "action": "",
      "before-upload": _vm.beforeAvatarUpload,
      "accept": "image/jpeg,image/png"
    }
  }, [(_vm.form.avatar) ? _c('img', {
    attrs: {
      "src": _vm.form.avatar,
      "width": "145",
      "height": "145"
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23023754"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/index.vue
// module id = 617
// module chunks = 1